import { useAppData } from "./App.tsx";
import IconCopy from "tabler-icons/copy.tsx";
import IconFile from "tabler-icons/file.tsx";
import IconDownlaod from "tabler-icons/download.tsx";
import type { Doc } from "db";
import { fetchOrError } from "../app/utils.ts";
import { Thinking } from "./Thinking.tsx";
import { useSignal } from "@preact/signals";

function copyRichContent(html: string, text: string) {
  const blob = new Blob([html], { type: 'text/html' });
  const textBlob = new Blob([text], { type: 'text/plain' });
  const data = new ClipboardItem({
    'text/html': blob,
    'text/plain': textBlob,
  });
  navigator.clipboard.write([data])
    .then(() => console.log('Rich content copied'))
    .catch(err => console.error('Failed to copy: ', err));
}

export function Messages() {
  const loadingDocument = useSignal<number>();
  const appData = useAppData();

  const messages = appData.messages.value;

  async function downloadDocument(doc: Doc) {
    loadingDocument.value = doc.id;

    try {

      const response = await fetch(`/api/document/${doc.id}`);

      if (!response.ok) {
        throw new Error(`Failed to download document: ${response.statusText}`);
      }

      // Get the filename from the Content-Disposition header if available
      const contentDisposition = response.headers.get('Content-Disposition');
      let filename = doc.filename || 'document';

      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="(.+)"/);
        if (filenameMatch) {
          filename = filenameMatch[1];
        }
      }

      // Get the blob directly from the response
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = filename;

      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      URL.revokeObjectURL(url);
    } finally {
      loadingDocument.value = undefined;
    }
  }

  function downloadAll() {
    const allDocuments = appData.documents.value;
    if (allDocuments.length === 0) return;

    for (const doc of allDocuments) {
      downloadDocument(doc);
    }

  }

  return <div className="center">
    {messages.map((message, i) =>
      <div class="message" data-role={message.role} key={i}>
        <Thinking thinking={message.thinking} />
        <div class="content" dangerouslySetInnerHTML={message.role == "assistant" ? { __html: message.content } : undefined}>{message.content}</div>

        <div className="toolbar">
          {message.role == 'assistant' && !!message.content.trim() && <button class="copy" onClick={() => copyRichContent(message.html!, message.content)}><IconCopy height={18} /></button>}

          <div class="documents">
            {appData.documents.value.filter(d => d.message_id == message.id).map(d =>
              d.type == 'image' ?
                <a class="document-image" href={`/api/images/${d.file_path}`} target="_blank" rel="noopener noreferrer" key={d.id} title={d.filename}>
                  <img src={`/api/images/${d.file_path}`} alt={d.filename} loading="lazy" />
                </a>
                :
                <button class="document" onClick={() => downloadDocument(d)} disabled={message.role == 'user' || loadingDocument.value == d.id} key={d.id} title={d.filename}>
                  <IconFile /><span class="filename">{d.filename}</span>
                </button>
            )}
            {appData.documents.value.filter(d => d.message_id == message.id).length > 2 && <button class="document" onClick={downloadAll}>
              <IconDownlaod /><span class="filename">Download All</span>
            </button>}
          </div>
        </div>

      </div>
    )}
  </div>
}